import { render, staticRenderFns } from "./ApiGeneral.vue?vue&type=template&id=97fae1d8&"
import script from "./ApiGeneral.vue?vue&type=script&lang=js&"
export * from "./ApiGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports